module.exports = __webpack_public_path__ + "static/media/dots.b06b3bd2.svg";